import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function addressHasStateValidator(dataControlName: string): ValidatorFn {
  return (ctrl: AbstractControl): ValidationErrors | null => {
    const text = (ctrl.value ?? '').toString().trim();
    if (!text) return null;

    const parent = ctrl.parent;
    const data = parent?.get(dataControlName)?.value;
    if (!data?.Province) return { missingState: true };

    return null;
  };
}
